export const ellipsesText = (str: string, limit: number) => {
  if (!str) return "";

  return str.length > limit ? str.substring(0, limit - 3) + "..." : str;
};
